import React, { lazy, Suspense } from 'react';
import * as Sentry from '@sentry/react';
import { Spinner } from 'reactstrap';
import { BrowserRouter as Router, Redirect, Route, Switch, withRouter } from 'react-router-dom';
import StoreProvider from './Store/StoreProvider';
import FrontNav from './Reports/Components/FrontNav';
import './App.scss';

const App = () => {
    const ReflectionsReport = {
        Filter: lazy(() => import('./Reports/Reflections/Pages/Filter')),
        Render: lazy(() => import('./Reports/Reflections/Pages/Render'))
    };
    const FuturesReport = {
        Filter: lazy(() => import('./Reports/Futures/Pages/Filter')),
        Render: lazy(() => import('./Reports/Futures/Pages/Render'))
    };
    const EngineeringReport = lazy(() => import('./Reports/Engineering/Pages/Page'));
    const MastersEngineeringReport = lazy(() => import('./Reports/MastersEngineering/Pages/Page'));
    const NavRouter = withRouter(({ location }) => <FrontNav location={location.pathname} />);
    return <Sentry.ErrorBoundary fallback={<>An error has occured</>} showDialog>
        <StoreProvider>
            <Suspense fallback={<div className='spinnerDiv'>
                <Spinner />
                Downloading Experiences
            </div>}
            >
                <Router>
                    <NavRouter />
                    <Switch>
                        <Route path='/reflections' exact><Redirect to='/reflections/filter' /></Route>
                        <Route path='/reflections/filter'><ReflectionsReport.Filter /></Route>
                        <Route path='/reflections/view'><ReflectionsReport.Render /></Route>

                        <Route path='/certificate' exact><Redirect to='/certificate/filter' /></Route>
                        <Route path='/certificate/filter'><FuturesReport.Filter /></Route>
                        <Route path='/certificate/view'><FuturesReport.Render /></Route>

                        <Route path='/engineering'><EngineeringReport /></Route>
                        <Route path='/mastersengineering'><MastersEngineeringReport /></Route>
                        <Route path='' exact />
                    </Switch>
                </Router>
            </Suspense>
        </StoreProvider>
    </Sentry.ErrorBoundary>;
};

export default App;
